import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "camera" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = ["width", "height"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, "登録しますか?", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_a_switch, {
        checked: _ctx.cameramode,
        "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.cameramode) = $event)),
        "checked-children": "フロントカメラ",
        "un-checked-children": "リアカメラ",
        onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.modeChange()))
      }, null, 8, ["checked"]),
      _hoisted_2,
      _createVNode(_component_a_select, {
        placeholder: "撮影場所を選択",
        options: _ctx.points,
        value: _ctx.point,
        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.point) = $event)),
        onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.modeChange()))
      }, null, 8, ["options", "value"]),
      _hoisted_3,
      _createElementVNode("video", {
        ref: "video",
        autoplay: "",
        playsinline: "",
        muted: "",
        width: _ctx.width,
        height: _ctx.width
      }, null, 8, _hoisted_4),
      _hoisted_5
    ]),
    _createVNode(_component_a_modal, {
      visible: _ctx.visible,
      title: "データ登録",
      onOk: _cache[4] || (_cache[4] = ($event: any) => (_ctx.post())),
      onCancel: _cache[5] || (_cache[5] = ($event: any) => (_ctx.cancel())),
      loading: _ctx.loading
    }, {
      default: _withCtx(() => [
        _createElementVNode("p", null, "読み取り成功:" + _toDisplayString(_ctx.data), 1),
        _createElementVNode("p", null, "撮影場所:" + _toDisplayString(_ctx.points.filter(e => e.value == _ctx.point)[0].label), 1),
        _hoisted_6
      ]),
      _: 1
    }, 8, ["visible", "loading"])
  ], 64))
}